/*
财务管理可通用api
 */
import request from './request';
import md5 from 'js-md5';
/* import { indexApi } from './indexApi'; */

const test = { name: 'name' };

// TIP 下拉枚举、列表枚举  之类的GET接口
const enumOptions_api = {
  // TIP 获取  交易类型  的枚举。
  getBusinessType () {
    return request.get('/gw/w/res/business_types');
  },
  getBusinessSubType () {
    return request.get('/gw/w/res/business_sub_types');
  },

  // TIP 获取  所有交易市场  的枚举。
  /**
   * FIXME 这里，直接去  store-Actions  去取就好。
   * 将会调用  【/v2/s/trading_area】接口。
   */
};

// TIP 和币种相关。
const coin_api = {

  // 基础币列表(获取所有币种)
  getBaseCoinList () {
    return request({
      url: '/api/s/coin/allCoin',
      method: 'get',
    });
  },
};

// TIP 账户总额统计  币种资产统计，以及  常用流水记录
const summaryFlow_api = {

  // TIP 获取资金账户的  总额  以及  流水记录
  getAccountDetail (form, current, size) {
    let params = {
      ...form,
    };
    params.current = current;
    params.size = size;
    for (let attr in params) {
      if ((params[attr] + '').length === 0) {
        delete params[attr];
      }
    }
    return request({
      url: '/api/account/detail',
      method: 'get',
      params,
    });
  },

  /**
   * 用户个人，币种资产
   * convertCoin 可选，返回  对应币种，转换为USDT之后，用USDT所表示的资产。（用USDT作为单位，衡量对应单个币种的资产）
   *             如果不填，直接返回  所有币种，使用USDT作为单位  所表示的资产。
   */
  get_CoinAssetSummary_ByUsdt (convertCoin) {
    return request({
      url: `/api/w/exchange/account/${convertCoin}`,
      method: 'get',
      params: {
      },
    });
  },

  /**
   * 获取个人资产，单个币种的资产
   * coinName 必填，返回  对应单个币种的资产
   */
  get_CoinAssetSummary_rawInfo (symbol) {
    return request({
      url: `/api/w/exchange/account/${symbol}`,
      method: 'get',
    });
  },

  /**
   * 币币交易，用户交易对账户资产
   */
  getAccountAsset (coin_symbol) {
    return request({
      url: `/api/account/asset/${coin_symbol}`,
      method: 'get',
    });
  },
  getAccountAsset2() {
    return request({
      url: '/user/get/bal',
      method: 'get',
    });
  },
};

// TIP 注释描述：【委托订单】相关
const entrustOrder_api = {
  // 委托列表（所有的）
  list_all (form, current, size) {
    let params = {
      ...form,
    };
    // formUtils.formDateRange(params, form);
    params.current = current;
    params.size = size;
    for (let attr in params) {
      if ((params[attr] + '').length === 0) {
        delete params[attr];
      }
    }
    return request({
      url: '/api/t/entrust',
      method: 'get',
      params: params,
    });
  },
  // 委托下单
  entrust_NewOrder (data) {
    return request({
      url: '/api/t/entrust',
      method: 'post',
      data,
    });
  },
  // 根据订单号，查询委托订单
  getById (orderId) {
    return request({
      url: `/api/t/entrust/${orderId}`,
      method: 'get',
    });
  },
  // 撤销一个订单
  cancel_single (data) {
    return request({
      url: '/api/t/entrust',
      method: 'delete',
      data,
    });
  },
  // 撤销所有委托订单
  cancel_all (data) {
    return request({
      url: '/api/t/entrust/cancel/all',
      method: 'delete',
      data,
    });
  },
  // 查询历史委托列表
  list_history (form, current, size) {
    let params = {
      ...form,
    };
    // formUtils.formDateRange(params, form);
    params.current = current;
    params.size = size;
    for (let attr in params) {
      if ((params[attr] + '').length === 0) {
        delete params[attr];
      }
    }
    return request({
      url: '/api/t/entrust/history',
      method: 'get',
      params: params,
    });
  },
  // 查询当前委托列表
  list_pending (form, current, size) {
    let params = {
      ...form,
    };
    // formUtils.formDateRange(params, form);
    params.current = current;
    params.size = size;
    for (let attr in params) {
      if ((params[attr] + '').length === 0) {
        delete params[attr];
      }
    }
    return request({
      url: '/api/t/entrust/pending',
      method: 'get',
      params: params,
    });
  },
};

// TIP 注释描述：【成交订单】相关
const turnoverOrder_api = {
  // TIP 查询成交订单（历史的）
  list_history (form, current, size) {
    let params = {
      ...form,
    };
    // formUtils.formDateRange(params, form);
    params.current = current;
    params.size = size;
    for (let attr in params) {
      if ((params[attr] + '').length === 0) {
        delete params[attr];
      }
    }
    return request({
      url: '/api/t/deal/order/history',
      method: 'get',
      params: params,
    });
  },
  // 根据编号，查询成交订单，详情
  getById (orderId) {
    return request({
      url: `/api/t/deal/order/${orderId}`,
      method: 'get',
    });
  },
};

// TIP 注释描述：【钱包地址】相关的接口
const walletAddress_api = {
  // 增删改查。
  create (data) {
    data = {
      ...data,
      payPassword: md5(data.payPassword),
    };
    return request({
      url: '/api/w/withdraw/address',
      method: 'post',
      data,
    });
  },
  delete (form) {
    let data = {
      ...form,
      id: md5(form.id),
    };

    return request({
      url: `/api/w/withdraw/address/${data.id}`,
      method: 'delete',
    });
  },

  getById (symbol) {
    return request({
      url: `/api/w/withdraw/address/${symbol}`,
      method: 'get',
    });
  },
};

// TIP 注释描述：【资产·提现】相关
const assetsWithdraw_api = {
  withdrawOperation (data) {
    data.payPassword = md5(data.payPassword); // 把密码，用md5进行加密。
    return request({
      url: '/api/w/withdraw/apply',
      method: 'post',
      data,
    });
  },
  cancel (orderId) {
    return request({
      url: `/api/w/withdraw/${orderId}`,
      method: 'delete',
    });
  },
  list_records (form, current, size) {
    let params = {
      ...form,
    };
    // formUtils.formDateRange(params, form);
    params.current = current;
    params.size = size;
    for (let attr in params) {
      if ((params[attr] + '').length === 0) {
        delete params[attr];
      }
    }
    return request({
      url: '/api/w/withdraw/records',
      method: 'get',
      params: params,
    });
  },
};

// TIP 注释描述：【资产·充值】相关
const assetsRecharge_api = {
  // TIP 获取充值记录
  list_records (form, current, size) {
    let params = {
      ...form,
    };
    // formUtils.formDateRange(params, form);
    params.current = current;
    params.size = size;
    for (let attr in params) {
      if ((params[attr] + '').length === 0) {
        delete params[attr];
      }
    }
    return request({
      url: '/api/w/deposit',
      method: 'get',
      params: params,
    });
  },
  // TIP 获取充值地址
  get_Recharge_address (symbol) {
    return request({
      url: `/api/w/deposit/address?symbol=${symbol}`,
      method: 'get',
    });
  },
};

// TIP 注释描述：和【内部转账】有关
const innerTransfer_api = {
  /**
   * 获取转账记录列表
    form => {
      coinId: '',
      beginDate: '2018-12-22',
      endDate: '2019-01-22',
    }
   */
  list (form, current, size) {
    let params = {
      ...form,
    };
    params.current = current;
    params.size = size;
    for (let attr in params) {
      if ((params[attr] + '').length === 0) {
        delete params[attr];
      }
    }
    return request({
      url: '/api/account/transfer',
      method: 'get',
      params: params,
    });
  },
  // 发起内部转账
  transferOperation (data) {
    data = {
      ...data,
      payPassword: md5(data.payPassword),
    };
    return request({
      url: '/api/account/transfer',
      method: 'post',
      data,
    });
  },
};

// TIP 注释描述：【银行卡管理】相关
export const bankManager_api = {
  /**
   * 添加银行卡
   * "bankBranch": "", // 支行
   "bankCard": "", // 卡号
   "bankId": "", // 银行卡ID
   "ga_code": "", // 谷歌验证码
   "realName": "", // 持卡人姓名
   "remark": "", // 备注
   */
  addBankCard (data) {
    return request({
      url: '/api/u/cards/bind',
      method: 'post',
      data,
    });
  },
  /*
   根据国家获取银行
  */
  getBanksByCountry (countryID) {
    return request.get('/v2/s/res/' + countryID);
  },
  /**
   * 获取银行卡列表，如果传递countryId则是获取指定国家对于的银行卡，否则获取所有绑定的银行卡
   */
  getUserBank (countryId) {
    let params = {};
    if (countryId) {
      params.currencyId = countryId;
    } else {
      params = null;
    }
    return request({
      url: '/api/u/cards',
      method: 'get',
      params,
    });
  },
  /*
    删除银行卡
   */
  delBankCard (bankCardId) {
    return request({
      url: '/api/u/cards',
      method: 'delete',
      params: {
        id: bankCardId,
      },
    });
  },
};

export const assetsApi = {

  get test () {
    return test;
  },

  get enumOptions_api () {
    return enumOptions_api;
  },

  get coin_api () {
    return coin_api;
  },

  get summaryFlow_api () {
    return summaryFlow_api;
  },

  get entrustOrder_api () {
    return entrustOrder_api;
  },

  get turnoverOrder_api () {
    return turnoverOrder_api;
  },

  get walletAddress_api () {
    return walletAddress_api;
  },

  get assetsWithdraw_api () {
    return assetsWithdraw_api;
  },

  get assetsRecharge_api () {
    return assetsRecharge_api;
  },

  get innerTransfer_api () {
    return innerTransfer_api;
  },

};
